import React, { useContext } from 'react';
import { SearchContext } from '../../context/Search';
import classes from '../TableContainer/index.module.scss';

const HEADER_PARAMS_REFACTORING = {
  class_code: "Class Code",
  contacts: "Contacts",
  description: "Description",
  naics: "NAICS Code",
  deadline: "Close Date",
  posted_date: "Request Date",
  sol_no: "Solicitation Number",
  office_address: "Office Address",
  sam_link: "Url",
  title: "Title",
  city: "City",
  state: "State",
  zip: "ZIP Code",
  required_date: "Date Required",
  link: "Url",
  name: "Title",
  comment: "Comment",
  quantity: "Quantity",
  setaside_code: "Business Type",
  closing_date: "Closing Date",
  address1: "Address",
  duns_number: "DUNS Number",
  email: "Email",
  fax: "Fax",
  keywords: "Keywords",
  phone: "Phone",
  url: "Url",
  contact: "Contact",
  county: "County",
  phone1: "Phone",
  username: "User Name",
  is_active: "Status",
  registration_date: "Registration Date",
  role_description: "Role",
  source_info: "Source Info"
}

const TableHeader = () => {
  const { headerParams } = useContext(SearchContext);

  return (
    <tr>
      {headerParams.map(item => {
        return (
          <th key={item} className={`${classes.No_Wrap} ${item === "description" || item === "comment" ? classes.Custom_Width : ""}`}>
            {HEADER_PARAMS_REFACTORING[item]}
          </th>
        )
      })}
    </tr>
  )
}

export default TableHeader;